import { render, staticRenderFns } from "./foodMenuApprovalTable.vue?vue&type=template&id=6ee09f5d&"
import script from "./foodMenuApprovalTable.vue?vue&type=script&lang=js&"
export * from "./foodMenuApprovalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports